export default function hideLoader() {
  const lo = document.querySelector('#loadingOverlay') as HTMLElement;
  if (!lo) {
    return;
  }
  const root = document.querySelector('#root');
  lo.style.opacity = '0';
  setTimeout(() => lo.remove(), 350);
  root?.classList.remove('hide');
}
